const WorkProcessStep = ({processText,per}) => {
    return(
        <div className="skill-container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "24px"

          }}
        >
          <div className="work-process-circle">
            <span style={{fontSize:"16px",fontWeight:"500",lineHeight:"20px"}}>{per}</span>
          </div>

          <div className="vertical-line"></div>
        </div>
        <div className="skill-label">{processText}</div>
      </div>
    )
}
export default WorkProcessStep;